import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-up",
  "use": "icon-chevron-up-usage",
  "viewBox": "0 0 11 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 7\" id=\"icon-chevron-up\"><path d=\"M9.6 7L5.5 2.9 1.4 7 0 5.6 5.5 0 11 5.6 9.6 7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol